module.exports = __webpack_public_path__ + "img/1.5357e2e1.svg";